import React from 'react';
import "./footer.css"

const Footer = () => {
    return (
        <footer className="border-top">
            <div className="footer-copyright txt-center m-auto">
                <p>Copyright © Crypto | Designed by Harshita Daswani</p>
            </div>
        </footer>
    )
}

export { Footer };
